export default CalculateOfferPrices = {
  setPriceFull({ product, defaultPrice, calculateFromIntro }) {
    return product?.amount ? (calculateFromIntro ? product?.intro_amount : product.amount) : defaultPrice;
  },

  setPriceFullV2({ product, defaultPrice, calculateFromIntro }) {
    return product?.amount ? (calculateFromIntro ? product?.trial_amount
      : product.amount) : defaultPrice;
  },

  setPriceInWeeks({ product, defaultPrice }) {
    return product?.amount ? Math.round((product.amount / 4.285) * 100) / 100 : defaultPrice;
  },

  setPriceInWeeksYearSubscr({ product, defaultPrice }) {
    return product?.amount ? Math.round((product.amount / 12 / 4.285) * 100) / 100 : defaultPrice;
  },

  setPriceOneDay({ product, month, defaultPrice }) {
    return product?.amount ? Math.floor((product.amount / month / 30) * 100) / 100 : defaultPrice;
  },

  setOldPriceOneDay({ amount, month, defaultPrice }) {
    return month ? Math.floor((amount / month / 30) * 100) / 100 : defaultPrice;
  },

  setPriceOneDayInYear({ product, defaultPrice }) {
    return product?.amount ? Math.round((product.amount / 12 / 31) * 100) / 100 : defaultPrice;
  },

  setPriceOneDayInSixMonths({ product, defaultPrice }) {
    return product?.amount ? Math.floor((product.amount / 6 / 31) * 100) / 100 : defaultPrice;
  },

  setPriceOneDaytrial({ product, defaultPrice, calculateFromIntro }) {
    if (product?.trial_amount && calculateFromIntro) {
      if (product?.duration?.trial_period_unit === 'day' && product?.duration?.trial_period_value) {
        return Math.floor(product.trial_amount / product.duration.trial_period_value * 100) / 100;
      } else if (product?.duration?.trial_period_unit === 'month' && product?.duration?.trial_period_value) {
        return Math.floor(product.trial_amount / product.duration.trial_period_value / 30 * 100) / 100;
      } else if (product?.duration?.trial_period_unit === 'week' && product?.duration?.trial_period_value) {
        return Math.floor(product.trial_amount / 7 * 100) / 100;
      }
    } else if (product?.amount) {
      if(product?.duration?.unit === 'month' && product?.duration?.value) {
        return Math.floor(product.amount / product.duration.value / 30 * 100) / 100;
      }
    } else {
      return defaultPrice;
    }
  },

  setOldPriceOneDayTrial({ amount, product, defaultPrice }) {
    if (amount) {
      if (product?.duration?.trial_period_unit === 'day' && product?.duration?.trial_period_value) {
        return Math.floor(amount / product.duration.trial_period_value * 100) / 100;
      } else if (product?.duration?.trial_period_unit === 'month' && product?.duration?.trial_period_value) {
        return Math.floor(amount/ product.duration.trial_period_value / 30 * 100) / 100;
      } else if (product?.duration?.trial_period_unit === 'week' && product?.duration?.trial_period_value) {
        return Math.floor(amount / 7 * 100) / 100;
      } else {
        return defaultPrice;
      }
    } else {
      return defaultPrice;
    }

  },

  setPriceMonthInYear({ product, defaultPrice }) {
    return product?.amount ? Math.round((product.amount / 12) * 100) / 100 : defaultPrice;
  },

  setPriceMonthInSixMonth({ product, defaultPrice }) {
    return product?.amount ? Math.round((product.amount / 6) * 100) / 100 : defaultPrice;
  },

  setPriceInWeeksV2({ product, defaultPrice }) {
    if(product?.amount && product?.duration.value) {
      return Math.round((product.amount / product.duration.value / 4.285) * 100) / 100;
    } else {
      return defaultPrice;
    }
  },

  setPriceInWeeksV3({ product, defaultPricesPerWeek }) {
    if(product?.amount && product?.duration.value) {
      return Math.floor((product.amount / product.duration.value / 4.285) * 100) / 100;
    } else {
      return defaultPricesPerWeek;
    }
  },

  setPriceInWeeksIntro({ product, defaultPricesPerWeek, calculateFromIntro }) {
    const amount = calculateFromIntro ? product?.trial_amount : product?.amount;
    const duration = product?.duration?.value;
  
    if (amount && duration) {
      return Math.floor((amount / duration / 4.285) * 100) / 100;
    }
  
    return defaultPricesPerWeek;
  },

  setPriceInWeeksYearSubscrV2({ product, defaultPricesPerWeek }) {
    return product?.amount ? Math.floor((product.amount / 12 / 4.285) * 100) / 100 : defaultPricesPerWeek;
  },

  setPriceInWeeksSixMonthsSubscrV2({ product, defaultPricesPerWeek }) {
    return product?.amount ? Math.floor((product.amount / 6 / 4.285) * 100) / 100 : defaultPricesPerWeek;
  },

  setOldPriceInWeeksYearSubscr({defaultPrice }) {
    return defaultPrice ? Math.floor((defaultPrice / 12 / 4.285) * 100) / 100 : defaultPrice;
  },

  setOldPriceInWeeksSixMonthsSubscr({defaultPrice }) {
    return defaultPrice ? Math.floor((defaultPrice / 6 / 4.285) * 100) / 100 : defaultPrice;
  },

  setOldPriceInWeek({ amount, month, defaultPrice }) {
    return month ? (Math.floor((amount / month / 4.285) * 100) / 100).toFixed(2) : defaultPrice;
  },

  setPriceOldOneDayInYear({ amount, defaultPrice }) {
    return amount ? Math.floor((amount / 12 / 30) * 100) / 100 : defaultPrice;
  },

  setPriceOldOneDayInSixMonths({ amount, defaultPrice }) {
    return amount ? Math.floor((amount / 6 / 30) * 100) / 100 : defaultPrice;
  },

  setPriceOneDayInWeek({ product, defaultPrice }) {
    return product?.amount ? Math.floor((product.amount / 7) * 100) / 100 : defaultPrice;
  },
};
